"use client";

import { ChevronDown } from "lucide-react";
import { useInView } from "@/hooks/useInView";
import { ScrollReveal } from "./ScrollReveal";
import { LandingSectionHeader } from "./LandingSectionHeader";
import { faqItems } from "./homepage-data";

export function LandingFAQ() {
  const [sectionRef, isVisible] = useInView<HTMLElement>(0.05);

  return (
    <section ref={sectionRef} className="bg-[hsl(var(--lb-bg-soft))] py-8 sm:py-14">
      <div id="faq" className="scroll-mt-20" />
      <div className="lb-container">
        <ScrollReveal>
          <LandingSectionHeader
            eyebrow="FAQ"
            title="Clear answers before you subscribe."
            copy="Billing, access, and what's included. No marketing fog."
            align="center"
          />
        </ScrollReveal>

        <div className="mx-auto mt-10 max-w-[78rem] border-t border-black/10">
          {faqItems.map((item, index) => (
            <details
              key={item.question}
              className="group border-b border-black/10 py-8"
              open={index === 0}
              style={{
                opacity: isVisible ? 1 : 0,
                transform: isVisible ? "none" : "translateY(16px)",
                transition: `opacity 0.6s cubic-bezier(0.22, 1, 0.36, 1) ${index * 70}ms, transform 0.6s cubic-bezier(0.22, 1, 0.36, 1) ${index * 70}ms`,
              }}
            >
              <summary className="flex cursor-pointer list-none items-center justify-between gap-8 text-[2rem] font-semibold leading-tight tracking-[-0.06em] text-black marker:hidden">
                {item.question}
                <ChevronDown className="h-7 w-7 shrink-0 text-black/35 transition group-open:rotate-180 group-open:text-black" />
              </summary>
              <p className="mt-6 max-w-[56rem] text-xl leading-[1.45] tracking-[-0.035em] text-black/58">{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
